module.exports = __webpack_public_path__ + "img/sld_mfm_ring_one.25a9fb3f.svg";